import dayjs from 'dayjs';
import { getPopupData, getPublisherData, redirect } from '.';
import { useTracking } from './TrackingContext';
import { publish } from './pubsub';
import { ActionType } from '../../../components/containers/_commons/busDirectoryHooks';
import { journeyTypeToShortValue } from '../../../helpers/utils';
import { formatDate, formatValue } from './helpers';
import openPopup from './_experimental/helpers/usePopupOpener';

export function useBusDirectoryTracking() {
  const container = useTracking();
  const { eventType, fareItemInteractionType } = container;

  return (state: $TSFixMe, action: $TSFixMe) => {
    const baseline: $TSFixMe = {
      currencyCode: container.currencyCode,
      departureDate: formatDate(container.departureDateStart),
      destinationAirportIataCode: formatValue(state.destination?.geoId),
      fareClass: formatValue(container.fareClass),
      flexibleDates: container.flexibleDates,
      journeyType: formatValue(container.flightType),
      originAirportIataCode: formatValue(state.origin?.geoId),
      promoCode: formatValue(container.promoCode),
      returnDate: formatDate(container.returnDateEnd),
      siteEdition: container.siteEdition
    };
    // Tag name is optional
    if (container.tagName) {
      baseline.tagName = container.tagName;
    }

    let journeyTypeMap;
    let defaultTracking;
    let fareState;
    let fareData;
    if (action.payload && action.payload.fare) {
      defaultTracking = {
        ...baseline,
        passengerCount: formatValue(container.passengerCount)
      };
      const { fare } = action.payload;
      journeyTypeMap = journeyTypeToShortValue() as $TSFixMe;
      fareState = {
        ...state,
        destination:
          state?.destination?.value !== undefined
            ? state?.destination?.value
            : state?.busStations[1]?.iataCode,
        origin:
          state?.origin?.value !== undefined
            ? state?.origin?.value
            : state?.busStations[0]?.iataCode,
        originCity: state.origin.name,
        destinationCity: state.destination.name,
        journeyType: journeyTypeMap[baseline.journeyType],
        flightType: baseline.journeyType,
        currencyCode: baseline.currencyCode,
        travelClass: baseline.fareClass
      };
      fareData = {
        ...fare,
        destinationAirportIataCode: formatValue(fareState.destination),
        originAirportIataCode: formatValue(fareState.origin),
        originCity: formatValue(fareState.originCity),
        destinationCity: formatValue(fareState.destinationCity),
        departureDate: formatDate(baseline.departureDate),
        returnDate: formatDate(baseline.returnDate),
        formattedDepartureDate: dayjs(baseline.departureDate).format('DD/MM/YYYY'),
        formattedReturnDate: dayjs(baseline.returnDate).format('DD/MM/YYYY')
      };
    }

    const send = (name: string, changes: $TSFixMe) =>
      publish(`em.fare.${eventType}.${name}`, { ...baseline, ...changes });

    switch (action.type) {
      case ActionType.ORIGIN_CHANGE: {
        return send('origin', { originAirportIataCode: formatValue(action.payload.geoId) });
      }
      case ActionType.DESTINATION_CHANGE: {
        return send('destination', {
          destinationAirportIataCode: formatValue(action.payload.geoId)
        });
      }
      case ActionType.SEARCH_STATIONS: {
        const { origin, destination } = action.payload;
        return send('search', {
          originAirportIataCode: formatValue(origin?.geoId),
          destinationAirportIataCode: formatValue(destination?.geoId)
        });
      }
      case ActionType.ZOOM: {
        const { oldZoom, newZoom } = action.payload;
        return send('zoom', { expanded: false, zoom: oldZoom > newZoom ? 'out' : 'in' });
      }
      case ActionType.STATION_CHANGE: {
        return send('change-location', { location: action.payload.iataCode });
      }
      case ActionType.STATION_SELECT: {
        return send('select-location', {
          location: action.payload.station.iataCode,
          callToActionLabel: action.payload.callToActionLabel
        });
      }
      case ActionType.LOAD_MORE_STATIONS: {
        return send('load-more', {});
      }
      case ActionType.FARE_CLICK: {
        const { fare, callToActionLabel } = action.payload;
        const label = (callToActionLabel as string)
          .split(' ')
          .map((l) => l[0].toUpperCase() + l.slice(1))
          .join('-');
        if (!fare) {
          return undefined;
        }
        if (typeof fare === 'object' && fare.constructor === Object) {
          if (fareItemInteractionType === 'deeplink') {
            publish(
              `em.fare.book.${eventType}`,
              getPublisherData({
                baseline: defaultTracking,
                fare: fareData,
                callToActionLabel: label
              })
            );
            redirect({ container, state: fareState, fare: fareData });
          }
          if (fareItemInteractionType === 'popup') {
            openPopup(getPopupData({ container, state: fareState, fare: fareData }));
            publish(
              `em.fare.popup.${eventType}`,
              getPublisherData({
                baseline: defaultTracking,
                fare: fareData,
                callToActionLabel: label
              })
            );
          }
        }
        return undefined;
      }
      default: {
        return undefined;
      }
    }
  };
}
